import { DataAttributesProps, FAKE_COMPONENT_NOEDIT_VALUE_LOC_KEY } from "@multiweb/reactComponents";
import { bridge } from "@multiweb/reactCore/bridge";
import { loadLocalizationIfNeeded } from "@multiweb/reactCore/i18n/externalUtils";
import { UUID } from "Global/Base/IDs/UUID";
import { OWObject } from "OW.Remoting/Remoting/DataTypes/OWObject";
import { createClearLinkButtonAction, createInitLinkButtonAction, createUpdateLinkButtonOptionsAction, LinkButtonProps } from "UI/UI.React/components/LinkButton";
import { IMultiEdit } from "UI/UI/UI/Controls/ControlInterfaces";
import { ControlUtils } from "UI/UI/UI/Controls/ControlUtils";
import { ControlConnectorWithActualObject } from "../ControlConnectorWithActualObject";
import { GenericControlConnectorAttrs } from "../GenericControlConnector";

const { dispatchAction, isNullOrEmpty } = bridge;

export class LinkButtonConnector extends ControlConnectorWithActualObject implements IMultiEdit {
    public readonly url?: string;
    public readonly params?: string[];
    public readonly functions?: string[];
    private _dataKey: string;
    private _multiEditActive: boolean = false;

    constructor(attrs: GenericControlConnectorAttrs, canRender: boolean = true) {
        super(attrs, false);

        const params = ControlUtils.getDataAttr("Params", this.element);
        const functions = ControlUtils.getDataAttr("Functions", this.element);

        this._dataKey = UUID.generate();
        this.url = ControlUtils.getDataAttr("URL", this.element);
        this.params = (isNullOrEmpty(params)) ? [] : params.split(";");
        this.functions = (isNullOrEmpty(functions)) ? [] : functions.split(";");

        dispatchAction(createInitLinkButtonAction(this._dataKey, this.url, this.params, this.functions));
        this._renderIfTrue(canRender);
    }

    public override get actualObject(): OWObject {
        return this._actualObject;
    }

    public override set actualObject(actualObject: OWObject | null) {
        super.actualObject = actualObject;

        dispatchAction(createUpdateLinkButtonOptionsAction(this._dataKey, actualObject?.instanceID));
    }

    public set multiEditActive(value: boolean) {
        if (this._multiEditActive === value)
            return;

        this._multiEditActive = value;
        loadLocalizationIfNeeded(FAKE_COMPONENT_NOEDIT_VALUE_LOC_KEY);
        super._render();
    }

    public get multiEditActive(): boolean {
        return this._multiEditActive;
    }

    public get touched(): boolean {
        return false;
    }

    protected override _getRenderProps(): LinkButtonProps & DataAttributesProps {
        return {
            ...super._getRenderProps(),
            dataKey: this._dataKey,
            multiEditActive: this.multiEditActive,
            touched: false,
        };
    }

    public override dispose(): void {
        super.dispose();
        dispatchAction(createClearLinkButtonAction(this._dataKey));
    }
}
